import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgAlarmClock = function SvgAlarmClock(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.696 3.357c3.998.94 6.836 4.629 6.834 8.884 0 2.79-1.234 5.424-3.346 7.148l2.152 2.234c.36.375.36.981 0 1.355a.909.909 0 01-1.305 0l-2.452-2.545a8.472 8.472 0 01-7.637 0L6.49 22.981a.912.912 0 01-1.305 0 .984.984 0 010-1.355l2.152-2.235c-3.22-2.631-4.256-7.228-2.493-11.07 1.763-3.842 5.854-5.903 9.852-4.964zm-1.935 1.697c-3.824 0-6.924 3.218-6.924 7.187.005 3.968 3.102 7.183 6.924 7.188 3.823 0 6.923-3.218 6.923-7.188 0-3.97-3.1-7.187-6.923-7.187z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M8.514 2.674a.49.49 0 00.12-.789A4.032 4.032 0 002.892 2c-1.574 1.634-1.622 4.267-.11 5.961a.458.458 0 00.411.149.464.464 0 00.348-.272c1.014-2.28 2.777-4.111 4.973-5.164zM19.684.741a4.058 4.058 0 00-2.8 1.145.49.49 0 00.12.788c2.196 1.053 3.96 2.883 4.973 5.164a.464.464 0 00.347.272.46.46 0 00.411-.148c1.12-1.256 1.416-3.082.754-4.649-.662-1.567-2.157-2.577-3.805-2.572zM15.53 11.283h-1.846V7.929c0-.53-.414-.959-.923-.959-.51 0-.924.43-.924.959v4.312c0 .53.414.959.924.959h2.769c.51 0 .923-.43.923-.959 0-.529-.413-.958-.923-.958z"
  }));
};

export default SvgAlarmClock;